/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _objectWithoutProperties } from '../_chunks/dep-92728dc5.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { isValidElement, forwardRef } from 'react';
import classNames from 'classnames';
import { i as isString_1 } from '../_chunks/dep-6c5254c6.js';
import { i as isObject_1 } from '../_chunks/dep-88cd50bf.js';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { CloseIcon, InfoCircleFilledIcon, CheckCircleFilledIcon } from 'tdesign-icons-react';
import { Button } from '../button/index.js';
import parseTNode from '../_util/parseTNode.js';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { useLocaleReceiver } from '../locale/LocalReceiver.js';
import { dialogCardDefaultProps } from './defaultProps.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import '../button/Button.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_util/easing.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';

var _excluded = ["theme", "header", "closeBtn", "footer", "body", "children", "className", "onCancel", "onConfirm", "onCloseBtnClick", "cancelBtn", "confirmBtn"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var renderDialogButton = function renderDialogButton(btn, defaultProps) {
  var result = null;
  if (isString_1(btn)) {
    result = /* @__PURE__ */React.createElement(Button, _objectSpread({}, defaultProps), btn);
  } else if ( /*#__PURE__*/isValidElement(btn)) {
    result = btn;
  } else if (isObject_1(btn)) {
    result = /* @__PURE__ */React.createElement(Button, _objectSpread(_objectSpread({}, defaultProps), btn));
  } else if (isFunction_1(btn)) {
    result = btn();
  }
  return result;
};
var DialogCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var componentCls = "".concat(classPrefix, "-dialog");
  var _useGlobalIcon = useGlobalIcon({
      CloseIcon: CloseIcon,
      InfoCircleFilledIcon: InfoCircleFilledIcon,
      CheckCircleFilledIcon: CheckCircleFilledIcon
    }),
    CloseIcon$1 = _useGlobalIcon.CloseIcon,
    InfoCircleFilledIcon$1 = _useGlobalIcon.InfoCircleFilledIcon,
    CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon;
  var _useLocaleReceiver = useLocaleReceiver("dialog"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var confirmText = t(local.confirm);
  var cancelText = t(local.cancel);
  var theme = props.theme,
    header = props.header,
    closeBtn = props.closeBtn,
    footer = props.footer,
    body = props.body,
    children = props.children,
    className = props.className,
    onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    onCloseBtnClick = props.onCloseBtnClick,
    _props$cancelBtn = props.cancelBtn,
    cancelBtn = _props$cancelBtn === void 0 ? cancelText : _props$cancelBtn,
    _props$confirmBtn = props.confirmBtn,
    confirmBtn = _props$confirmBtn === void 0 ? confirmText : _props$confirmBtn,
    otherProps = _objectWithoutProperties(props, _excluded);
  var renderHeader = function renderHeader() {
    if (!header) return null;
    var iconMap = {
      info: /* @__PURE__ */React.createElement(InfoCircleFilledIcon$1, {
        className: "".concat(classPrefix, "-is-info")
      }),
      warning: /* @__PURE__ */React.createElement(InfoCircleFilledIcon$1, {
        className: "".concat(classPrefix, "-is-warning")
      }),
      error: /* @__PURE__ */React.createElement(InfoCircleFilledIcon$1, {
        className: "".concat(classPrefix, "-is-error")
      }),
      success: /* @__PURE__ */React.createElement(CheckCircleFilledIcon$1, {
        className: "".concat(classPrefix, "-is-success")
      })
    };
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(componentCls, "__header-content")
    }, iconMap[theme], header);
  };
  var renderCloseBtn = function renderCloseBtn() {
    if (!closeBtn) return null;
    var closeIcon = function closeIcon() {
      return closeBtn === true ? /* @__PURE__ */React.createElement(CloseIcon$1, null) : closeBtn;
    };
    return /* @__PURE__ */React.createElement("span", {
      className: "".concat(componentCls, "__close"),
      onClick: function onClick(e) {
        return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    }, closeIcon());
  };
  var renderFooter = function renderFooter() {
    if (footer === false) return null;
    var defaultFooter = function defaultFooter() {
      var renderCancelBtn = renderDialogButton(cancelBtn, {
        variant: "outline",
        onClick: function onClick(e) {
          return onCancel === null || onCancel === void 0 ? void 0 : onCancel({
            e: e
          });
        }
      });
      var renderConfirmBtn = renderDialogButton(confirmBtn, {
        theme: "primary",
        onClick: function onClick(e) {
          return onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm({
            e: e
          });
        }
      });
      return /* @__PURE__ */React.createElement(React.Fragment, null, renderCancelBtn, renderConfirmBtn);
    };
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(componentCls, "__footer")
    }, parseTNode(footer, null, defaultFooter()));
  };
  return /* @__PURE__ */React.createElement("div", _objectSpread(_objectSpread({
    ref: ref
  }, otherProps), {}, {
    className: classNames(componentCls, "".concat(componentCls, "--default"), className)
  }), /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(componentCls, "__header"))
  }, renderHeader(), renderCloseBtn()), /* @__PURE__ */React.createElement("div", {
    className: "".concat(componentCls, "__body")
  }, body || children), renderFooter());
});
DialogCard.displayName = "DialogCard";
DialogCard.defaultProps = dialogCardDefaultProps;

export { DialogCard as default };
//# sourceMappingURL=DialogCard.js.map
